module.exports = __webpack_public_path__ + "static/media/b2c-image-lazada.8db1f50c.png";